import React from 'react';
import { connect } from 'react-redux';

import ColoredSectionContainer from 'components/no-auth/common/ColoredSectionContainer';
import { PromoPageContainer } from 'components/no-auth/common/promo-page-container/PromoPageContainer';
import { HeroSection } from 'components/no-auth/common/sections/HeroSection';
import { TilesSection } from 'components/no-auth/common/sections/TilesSection';
import NotAuthBasePage from 'components/no-auth/NotAuthBasePage';

import { TextComponent } from '../components/no-auth/common/sections/styles';

const PartnersPage = (props) => {
    return (
        <PromoPageContainer bgColor="eggshell03">
            {props.heroTitle && (
                <HeroSection title={props.heroTitle} text={props.heroText} data={props.heroData} btnVariant="primary" noIconBtn isInvertedBtn />
            )}
            {props.tiles3 && (
                <ColoredSectionContainer>
                    <TextComponent>
                        <TilesSection data={props.tiles3} grayText />
                    </TextComponent>
                </ColoredSectionContainer>
            )}
        </PromoPageContainer>
    );
};

const mapStateToProps = (state) => {
    return {
        heroTitle: state.extra?.strapiApi?.hero_block?.title,
        heroText: state.extra?.strapiApi?.hero_block?.text,
        heroData: state.extra?.strapiApi?.hero_block,
        tiles3: state.extra?.strapiApi?.tiles_section3,
    };
};

export default connect(mapStateToProps)(NotAuthBasePage(PartnersPage));
